import Api from '../utils/Api';
import Config from '../config/Config';

class DesafioService {
  constructor() {
    this.url = Config.URL_SERVICE;
    this.api = new Api({ url: this.url });
    this.api.createEntities([{ name: 'tarjetacoordenada' }, { name: 'tercerfactor' }]);
  }

  obtenerCoordenadas(trackId,desafioNuevo) {
    const config = { headers: { 'trackId': trackId } };
    return this.api.endpoints.tarjetacoordenada
      .getWithParams('obtenerdesafio',`refrescar=${desafioNuevo}`,config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }

  obtenerSms(trackId,idFlujo) {
    const config = { headers: { 'trackId': trackId, 'idFlujo':idFlujo } };
    return this.api.endpoints.tercerfactor
      .getWithAction('enviar',config)
      .then(response => {
        return response.data;
      })
      .catch(error => {
        throw error;
      });
  }
  

}


export default new DesafioService;